import { useState, useEffect } from 'react';
import { calculateLottoTax } from '../../../utils/lottoTax';

export const useLottoTaxCalculator = () => {
  // 1등 평균 당첨금(약 25억)을 기본값으로 설정
  const [winningAmount, setWinningAmount] = useState<number | ''>(2500000000);
  const [result, setResult] = useState<{
    totalWinnings: number;
    taxAmount: number;
    netWinnings: number;
  } | null>(null);

  const handleCalculate = () => {
    if (typeof winningAmount === 'number' && winningAmount > 0) {
      const calculationResult = calculateLottoTax(winningAmount);
      setResult(calculationResult);
    } else {
      setResult(null);
    }
  };

  // 컴포넌트가 처음 마운트될 때 기본값으로 계산을 실행
  useEffect(() => {
    handleCalculate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // 마운트 시 1회 실행

  return {
    winningAmount,
    setWinningAmount,
    result,
    handleCalculate,
  };
};